module.exports = __webpack_public_path__ + "bfcce4ed56e07ec5f2c825470fe47021.pdf";